module.exports = __webpack_public_path__ + "static/media/check-mark-on.9c8f97f0.svg";